import { useQuery } from "@tanstack/react-query"
import { getComplainById } from "@/lib/api/complain.api"
import { useAuthStore } from "@/store/auth.store"

export function useGetComplainById(id: string | null) {
  const accessToken = useAuthStore((s) => s.accessToken)

  return useQuery({
    queryKey: ["complain", id],
    queryFn: () => getComplainById(id!, accessToken!),
    enabled: !!accessToken && !!id,
    staleTime:0,
  })
}
